import SummariesPersonalRegisteredWithVat from "@/views/summaries/personal_registered_with_vat/index.vue";
import SummariesPersonalRegisteredWithoutVat from "@/views/summaries/personal_registered_without_vat/index.vue";
import SummariesPersonalNotRegister from "@/views/summaries/personal_not_register/index.vue";
import SummariesPersonalNormalNeedRegister from "@/views/summaries/personal_normal_need_register/index.vue";
import SummariesPersonalNormalNotRegister from "@/views/summaries/personal_normal_not_register/index.vue";

import SummariesCorpRegisteredWithVat from "@/views/summaries/corp_registered_with_vat/index.vue";
import SummariesCorpRegisterdWithoutVat from "@/views/summaries/corp_registered_without_vat/index.vue";
import SummariesCorpNotRegister from "@/views/summaries/corp_not_register/index.vue";
import SummariesCorpNormalNeedRegister from "@/views/summaries/corp_normal_need_register/index.vue";
import SummariesCorpNormalNotRegister from "@/views/summaries/corp_normal_not_register/index.vue";

import SummariesCorpDecision from "@/views/summaries/corp_decision/index.vue";
import SummariesPersonalDecision from "@/views/summaries/personal_decision/index.vue";

export default [
  {
    path: "/final_summaries/personal_registered_with_vat",
    name: "FinalSummariesPersonalRegisteredWithVat",
    component: SummariesPersonalRegisteredWithVat,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/personal_registered_without_vat",
    name: "FinalSummariesPersonalRegisteredWithoutVat",
    component: SummariesPersonalRegisteredWithoutVat,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/personal_normal_need_register",
    name: "FinalSummariesPersonalNormalNeedRegister",
    component: SummariesPersonalNormalNeedRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/personal_not_register",
    name: "FinalSummariesPersonalNotRegister",
    component: SummariesPersonalNotRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/personal_normal_not_register",
    name: "FinalSummariesPersonalNormalNotRegister",
    component: SummariesPersonalNormalNotRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_not_register",
    name: "FinalSummariesCorpNotRegister",
    component: SummariesCorpNotRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_normal_need_register",
    name: "FinalSummariesCorpNormalNeedRegister",
    component: SummariesCorpNormalNeedRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_normal_not_register",
    name: "FinalSummariesCorpNormalNotRegister",
    component: SummariesCorpNormalNotRegister,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_registered_with_vat",
    name: "FinalSummariesCorpRegisteredWithVat",
    component: SummariesCorpRegisteredWithVat,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_registered_without_vat",
    name: "FinalSummariesCorpRegisterdWithoutVat",
    component: SummariesCorpRegisterdWithoutVat,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/personal_decision",
    name: "FinalSummariesPersonalDecision",
    component: SummariesPersonalDecision,
    props: { hasFinalTaxType: true },
  },
  {
    path: "/final_summaries/corp_decision",
    name: "FinalSummariesCorpDecision",
    component: SummariesCorpDecision,
    props: { hasFinalTaxType: true },
  },
];
